import './InlineFilePreviewView.css';
import { jsxs as w, jsx as i, Fragment as R } from "react/jsx-runtime";
import P from "clsx";
import x, { useRef as A, useState as N, useEffect as I, useMemo as d, useCallback as k } from "react";
import "./usePageLifecycle.consts.mjs";
import { truncateMiddle as H } from "./truncateMiddle.mjs";
import "./getCentsSeparatorByCurrencyCode.mjs";
import "./getCurrencyCodeBySymbol.mjs";
import "./getCurrencyCodeFromString.mjs";
import "./getCurrencyCodeRTL.mjs";
import "./getCurrencySymbolByCode.mjs";
import "./getCurrencySymbolPlaceByCode.mjs";
import "./getCurrencySymbolSeparatorByCode.mjs";
import "big.js";
import "./getSeparatorByCurrencyCode.mjs";
import "./stringToBigFormat.mjs";
import "./moneyUtils.consts.mjs";
import { A as V } from "./ActionsControls-BrOv771p.js";
import { F as T } from "./FileExtensionIcon-BjXIuwJw.js";
import { getFilePreviewSize as j } from "./InlineFilePreviewView.utils.mjs";
const z = "_container_1qx7q_1", G = "_clickable_1qx7q_12", L = "_wrapper_1qx7q_15", O = "_imageWrapper_1qx7q_22", X = "_noPreview_1qx7q_27", $ = "_img_1qx7q_28", D = "_showMore_1qx7q_44", J = "_fileName_1qx7q_63", K = "_actionsPopup_1qx7q_67", Q = "_actionsPopupCenter_1qx7q_75", e = {
  container: z,
  clickable: G,
  wrapper: L,
  imageWrapper: O,
  noPreview: X,
  img: $,
  showMore: D,
  fileName: J,
  actionsPopup: K,
  actionsPopupCenter: Q
}, Y = 16, Z = 6, U = ({ name: s = "", previewImageUrl: o, imageHeight: a, showMore: r }) => {
  const l = A(null), [_, p] = N(!1);
  let t = null;
  I(() => {
    (o || !o) && p(!1);
  }, [o]);
  const c = !!(o && !_);
  c ? t = /* @__PURE__ */ i(
    "img",
    {
      src: o,
      onError: ({ currentTarget: u }) => {
        u.onerror = null, p(!0);
      },
      alt: s
    }
  ) : t = /* @__PURE__ */ i(T, { fileName: s, noPreviewClassName: e.noPreview });
  const m = d(
    () => ({
      height: a,
      fontSize: a
    }),
    [a]
  );
  return /* @__PURE__ */ w(
    "div",
    {
      ref: l,
      className: P({
        [e.imageWrapper]: !0,
        [e.showMore]: !!r,
        [e.img]: c
      }),
      style: m,
      children: [
        t,
        r ? /* @__PURE__ */ i("div", { className: e.showMore, children: `+${r.number}` }) : null
      ]
    }
  );
}, ee = x.memo(U), oe = ({
  name: s,
  previewImageUrl: o,
  availableActions: a = [],
  imageHeight: r,
  imageRatio: l = 1,
  maxFileNameLength: _ = Y,
  className: p = "",
  actionsPopupClassName: t = "",
  showMore: c,
  onClick: m,
  onMouseDown: u,
  onMouseLeave: C,
  onMouseUp: W,
  onTouchEnd: v,
  onTouchMove: y,
  onTouchStart: E
}) => {
  const [f, S] = N(null), b = k((n) => {
    n && S(n);
  }, []), B = P({
    [e.container]: !0,
    [e.clickable]: !!m,
    [p]: !!p
  }), { imageHeight: F, wrapperWidth: h, wrapperStyle: q } = d(() => {
    const { imageHeight: n, wrapperWidth: g } = j(r, l);
    return { imageHeight: n, wrapperStyle: {
      width: o ? g : n
    }, wrapperWidth: g };
  }, [r, o, l]), M = d(() => {
    const n = !!(f && h - Z * 2 < f.getBoundingClientRect().width);
    return P({
      [e.actionsPopup]: !0,
      [e.actionsPopupCenter]: n,
      [t]: !!t
    });
  }, [h, f, t]);
  return /* @__PURE__ */ w("div", { className: B, style: q, children: [
    /* @__PURE__ */ i(
      "button",
      {
        className: e.wrapper,
        style: q,
        onClick: m,
        onMouseDown: u,
        onMouseLeave: C,
        onMouseUp: W,
        onTouchEnd: v,
        onTouchMove: y,
        onTouchStart: E,
        children: /* @__PURE__ */ i(
          ee,
          {
            name: s,
            previewImageUrl: o,
            imageHeight: F,
            showMore: c
          }
        )
      }
    ),
    c ? null : /* @__PURE__ */ w(R, { children: [
      /* @__PURE__ */ i("div", { className: e.fileName, children: H(s || "", _) }),
      /* @__PURE__ */ i(
        V,
        {
          actions: a,
          ref: b,
          className: M
        }
      )
    ] })
  ] });
}, Ne = x.memo(oe);
export {
  Ne as I
};
//# sourceMappingURL=InlineFilePreviewView-DUO9MJCk.js.map
